import { Navigate, useLocation } from "react-router-dom";
import { useAdmin } from "./AdminContext";

export function RequireAdmin({ children }) {
  const { status } = useAdmin();
  const location = useLocation();

  if (status === "idle" || status === "checking") {
    return (
      <div className="min-h-[60vh] grid place-items-center text-sm text-muted-foreground" data-testid="admin-loading">
        <span className="opacity-60">Bezig met laden…</span>
      </div>
    );
  }
  if (status !== "authed") {
    return <Navigate to="/admin/login" state={{ from: location.pathname + location.search }} replace />;
  }
  return children;
}
